import { KarmaContent } from '../my-working-report/karma-content.model';
import { SkillDepartmentProgressResponse, SkillTrainingProgressResponse } from '../common/skill-learning/models/skill-learning.model';

const ZERO = 0;
const NUMBER_TYPE = 'number';
const KARMA_UP = 'UP';
const KARMA_DOWN = 'DOWN';

export function profileKarmaTotal(entries: KarmaContent[]): number | null {
  if (!Array.isArray(entries) || entries.some(entry => !validKarmaEntry(entry))) { return null; }
  return entries.reduce((total, entry) => total + (entry.direction === KARMA_UP ? entry.amount : -entry.amount), ZERO);
}

function validKarmaEntry(entry: KarmaContent): boolean {
  return !!entry && typeof entry.amount === NUMBER_TYPE && isFinite(entry.amount)
    && (entry.direction === KARMA_UP || entry.direction === KARMA_DOWN);
}

export function collectProfileTrainings(departments: SkillDepartmentProgressResponse[]): SkillTrainingProgressResponse[] {
  const seen = new Set<string>();
  const trainings: SkillTrainingProgressResponse[] = [];
  departments.forEach(department => (department.trainings || []).forEach(training => {
    if (training.completedLevels > ZERO && !seen.has(training.specializationId)) {
      seen.add(training.specializationId);
      trainings.push(training);
    }
  }));
  return trainings;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-profile/my-profile-summary.presentation.ts